<template>
  <v-toolbar flat color="transparent" class="mb-4">
    <icon-text-button
      v-if="showBackButton"
      icon="mdi-arrow-left-circle-outline"
      @click="back"
    >
    </icon-text-button>
    <v-toolbar-title>
      <v-icon v-if="icon" left large>{{ icon }}</v-icon>
      {{ title }}</v-toolbar-title
    >
    <v-spacer></v-spacer>
    <v-btn
      v-for="(button, index) in buttons"
      :key="index"
      :color="button.color"
      text
      class="ml-2"
      @click="buttonClick(button.key)"
    >
      <v-icon v-if="button.icon" :left="button.label != null">{{
        button.icon
      }}</v-icon>
      <span v-if="button.label">{{ button.label }}</span>
    </v-btn>
  </v-toolbar>
</template>

<script>
import IconTextButton from "./IconTextButton.vue";

export default {
  name: "PageTitle",

  components: { IconTextButton },

  props: {
    showBackButton: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: null,
    },
    buttons: {
      type: Array,
      default() {
        return [];
      },
    },
    icon: {
      type: String,
    },
  },

  methods: {
    back() {
      this.$router.go(-1);
    },
    buttonClick(key) {
      this.$emit("button-click", key);
    },
  },
};
</script>